<template>
  <div class="main-content">
    <div class="top-cont">
      <div class="head">
        <!-- <p>
          <span :class="{'active': tabType == 5}" @click="tabType = 5">抽奖记录</span>
        </p> -->
        <p>
          <span :class="{'active': tabType == 4}" @click="headedClick(4)">奖励统计</span>
        </p>
        <p>
          <span :class="{'active': tabType == 3}" @click="headedClick(6)">双11中奖记录</span>
        </p>
        <!-- <p>
          <span :class="{'active': tabType == 1}" @click="tabType = 1">电子奖券<template v-if="couponList">({{couponList.length}})</template></span>
        </p> -->
        <!-- <p><span :class="{'active': tabType == 2}" @click="tabType = 2">参会二维码</span></p> -->
      </div>
    </div>
    <div class="voucher-list" v-if="tabType == 1">
      <div class="list" :class="{'gray':[4,5].indexOf(item.State) >= 0 }" v-for="(item,index) in couponList" :key="index">
        <span class="look-source" @click="sourceByCoupon = item">查看来源</span>
        <div class="win-prize">
          <p class="print" v-if="item.State === 1">待激活打印</p>
          <!-- {{item.StartTime}}<br /> -->
          <p class="pad" v-else-if="item.State === 2">No.{{item.CouponCode}}</p>
          <p class="pad" v-else>已激活</p>
          <div class="prize-name" v-if="item.PrizeGrade && item.PrizeGradeName">
            <p class="ellipsis1">{{item.PrizeGradeName}}</p>
            <span @click="pageJump(1,'/recruit/html/AnimalLogistics.html')" class="view-delivery" v-if="item.ExpressNum">查看物流</span>
          </div>
          <!-- <img v-else src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20210901105640988.png" class="logo-small"> -->
        </div>
        <img v-if="item.State === 5" src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20210901105548003.png" class="chapter" />
        <img v-else-if="item.State === 4" src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20210901105603347.png" class="chapter" />
        <img v-else-if="item.State === 3 && !item.PrizeGrade" src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20210901105527331.png" class="chapter">
      </div>
    </div>
    <div class="empty-content" v-if="couponList.length <= 0 && tabType == 1">
      <img src="../../../assets/images/empty/coupon.png" />
      <p>暂无奖券</p>
    </div>
    <div class="layer" v-if="sourceByCoupon">
      <div class="source">
        <span class="modal-cha icon--4" @click="sourceByCoupon = null"></span>
        <div class="so-tit">奖券来源</div>
        <div class="so-cont">
          <p><span>来源：</span>{{sourceByCoupon.Source}}</p>
          <p><span>时间：</span>{{sourceByCoupon.SourceTime}}</p>
        </div>
      </div>
    </div>
    <div class="qr-code" v-if="tabType == 2">
      <!-- <div class="qr-title">
            <img src="../../img/goldenNine/theme.png" class="theme"/>
            <template v-if="perInfo">
                <img src="../../img/goldenNine/pk_01.png" class="level-logo" v-if="perInfo.level === 2"/>
                <img src="../../img/goldenNine/pk_02.png" class="level-logo" v-if="perInfo.level === 3"/>
            </template>
        </div> -->
      <div class="qr-cont" v-if="perInfo">
        <div class="room-num" v-if="perInfo.level === 1">
          <p class="txt1">团队名称:</p>
          <div class="txt3">
            <p><span class="txt-large">{{perInfo.groupName}}</span></p>
            <p><span class="txt-black">团队业绩：</span><span class="performance">￥{{perInfo.perf}}</span></p>
          </div>
        </div>
        <div class="room-num" v-else>
          <p class="txt1">当前排名（{{perInfo.listName}}:{{perInfo.gradeDesc}}）</p>
          <div class="txt3">
            <p><span class="txt-large">{{perInfo.listGrade}}</span>名</p>
            <p><span class="txt-black">团队业绩：</span><span class="performance">￥{{perInfo.perf}}</span></p>
          </div>
        </div>
        <div class="qrcode-img">
          <img :src="appHost + '/OnlyOnce/Activity201909/GetQr'">
        </div>
      </div>
      <div class="qr-cont" v-else-if="userInfo">
        <div class="room-num">
          <p class="txt2" v-if="userInfo.IsArrive">已签到</p>
          <p class="txt2" v-else>会场激活</p>
        </div>
        <div class="qrcode-img">
          <img :src="appHost + '/OnlyOnce/AnnualMeeting/GetQr'">
        </div>
        <!-- <p class="no-code" v-else>蜜蛋小姐姐提示您：报名成功后由公司统一激活噢!</p> -->
      </div>
      <div class="md-logo">
        <img src="http://freesaasofficedata.oss.aliyuncs.com/rolorweb/20230413112558680.png">
      </div>
    </div>
    <div class="ivv-layer" v-if="newYearLuckyInfo && tabType === 3">
      <div class="content years-cont">
        <div class="title">2025年蜜蛋年会</div>
        <div class="y-list">
          <span>年会基金券金额:</span>
          <div class="li">
            <!-- <p><em>{{newYearLuckyInfo.fundMoney}}</em>元({{newYearLuckyInfo.state?'已激活':'未激活'}})</p> -->
            <p><em>{{newYearLuckyInfo.fundMoney}}</em>元</p>
            <!-- <p>{{newYearLuckyInfo.fundMoneyStr}}</p> -->
          </div>
        </div>
        <div class="y-list">
          <span>年会抽奖券:</span>
          <div class="li">
            <p><em>{{newYearLuckyInfo.prizeDrawNum}}</em>张</p>
            <!-- <p>{{newYearLuckyInfo.prizeDrawNumStr}}</p> -->
          </div>
        </div>
        <div class="y-list" v-if="newYearLuckyInfo.mixedAccountPrizeList.length > 0">
          <span>采购券充值累积获赠:</span>
          <div class="li">
            <p v-for="(item,index) in newYearLuckyInfo.mixedAccountPrizeList" :key="index">{{item.prizeName}}<em class="rig">{{item.num}}</em>套</p>
          </div>
        </div>
        <div class="hint">注:年会基金券/年会抽奖券均须到现场激活</div>
      </div>
    </div>
    <div class="ivv-layer" v-if="gratitudeData && tabType === 4">
      <div class="content years-cont" style="border-color:#ffb5bb;" v-if="gratitudeData.isShow">
        <div class="title">蔓薇采购累计奖励</div>
        <div class="y-list" v-if="gratitudeData.allNum > 0">
          <span>活动商品累计订货盒数:<em>{{gratitudeData.allNum}}盒</em></span>
          <div class="li" v-for="(item,index) in gratitudeData.goodsStatistics.goodsList" :key="index">
            <p>{{item.goodsName}}:{{item.goodsCount}}盒</p>
          </div>
        </div>
        <div class="y-list " :class="gratitudeData.allNum>0?'y-list-margin':''">
          <span>获得奖励商品数量:</span>
          <div class="li">
            <p><em>蔓薇红参气血饮:{{gratitudeData.goodsStatistics.prizeCount2}}盒</em></p>
          </div>
          <div class="li">
            <p><em>蔓薇维D液体钙:{{gratitudeData.goodsStatistics.prizeCount3}}盒</em></p>
          </div>
        </div>
        <div class="y-list" v-if="gratitudeData.goodsStatistics.expressList.length > 0">
          <div class="li" v-for="(item,index) in gratitudeData.goodsStatistics.expressList" :key="index">
            <p>
              物流单号：{{item.expressNum}} <van-tag type="primary" round @click="copyExpress(item.expressNum)">复制</van-tag>
              </p>
          </div>
        </div>
      </div>

    </div>
    <div class="ivv-layer" v-if="tabType === 5">
      <div class="slot-record-list">
        <div class="title">
          <img src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20250923100820645.png" />
        </div>
        <div class="record-list">
          <van-empty v-if="finished && datalist.length <= 0 " class="custom-image" image="http://freesaasofficedata.oss.aliyuncs.com/miShop/20211210103825505.png" description="暂无中奖记录" />
          <template v-else>
            <div class="record-item" v-for="(item,index) in datalist" :key="index">
              <img :src="item.prizeImg" />
              <div class="git-cont">
                <div class="name">{{ item.prizeName }}</div>
                <div class="time">{{ item.dateTimes }}</div>
              </div>
              <div class="state">领取成功</div>
            </div>
          </template>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { replaceAppToken, deliveryMessage } from "../../../utils/appUtil";

export default {
  name: "AnnualMeetCoupons",
  data() {
    return {
      active: 0,
      couponList: [],
      sourceByCoupon: null,
      token: '',
      tabType: 4,
      userInfo: null,
      perInfo: null,
      gradeName: ["一等奖", "二等奖", "三等奖", "四等奖"],
      newYearLuckyInfo: null,
      isInApp: false,
      appHost: this.appHost,
      gratitudeData: null,
      datalist: [],
      finished: false,
    }
  },
  created() {
    let { token, inapp } = this.$route.query;
    if (token) {
      this.isInApp = true;
      this.token = token;
      replaceAppToken(token, () => {
        this.initFun();
      });
    } else {
      if (inapp === '1') this.isInApp = true;
      this.initFun();
    }

  },
  methods: {
    headedClick(type) {
      if (type == 6) {
        this.$router.push(`/lottery/slotRecord?type=${type}`);
      } else {
        this.tabType = type;
      }
    },
    copyExpress(expressNum) {
      this.$copyText(expressNum);
      this.$toast('复制成功');
    },
    getList() {
      this.$toast.loading({ message: '加载中...', duration: 0, overlay: true });
      this.get("/OrderGoods/Activity/GetGeneralprizeList", { isAll: 0,v:2 }, 2).then(json => {
        this.$toast.clear();
        this.finished = true;
        if (json.code === 1) {
          this.datalist = json.response;
        }
      });
    },
    initFun() {
      this.getCouponList()
      this.getAccountBalance()
      // this.getPerformance()
      this.getSignInfo()
      // this.getList()
    },
    //获取业绩信息
    getPerformance() {
      // this.$toast.loading({ message: "加载中...", duration: 0, mask: true });
      this.get("/OnlyOnce/OfflinePKCompetition/GetPersonalGrade").then(json => {
        // this.$toast.clear();
        if (json.code === 1) {
          this.perInfo = json.response.coupons;
        }
      });
    },
    //获取签到信息
    getSignInfo() {
      // this.$toast.loading({ message: "加载中...", duration: 0, mask: true });
      this.get("/MiMall/AnnualMeeting/GetUserSignInfo").then(json => {
        // this.$toast.clear();
        if (json.code === 1) {
          this.userInfo = json.response;
        }
      });
    },
    getAccountBalance() {
      this.$toast.loading({ message: '加载中...', duration: 0, mask: true });
      this.post('/PersonCenter/TeamAgent/GetAccountBalance', {
        brandId: 3
      }, true, 2).then(json => {
        this.$toast.clear();
        if (json.code === 1) {
          this.newYearLuckyInfo = json.response.orderLuckydrawNum2;
          let activityTips = json.response.activityTips;
          let goodsList = activityTips.goodsStatistics.goodsList;
          activityTips.allNum = 0;
          if (goodsList.length > 0) { 
            goodsList.forEach(item => {
              activityTips.allNum += item.goodsCount;
            });
          }
          console.log(activityTips);
          this.gratitudeData = activityTips;
        } else {
          return this.$dialog.alert({ title: '提示', message: json.msg }).then(() => {
            if (this.isInApp) deliveryMessage({ 'action': 'goHome' })
            else this.$router.push("/")
          })
        }
      })
    },
    getCouponList: function () {
      // this.$toast.loading({ message: "加载中...", duration: 0, mask: true });
      this.get("/MiMall/AnnualMeeting/GetUserCoupons").then(json => {
        // this.$toast.clear();
        if (json.code === 1) {
          this.couponList = json.response.coupons;
        }
      });
    },
    pageJump(type, path) {
      if (!path) return;
      if (type === 1) {
        window.location.href = this.baseHost + "/7999" + path;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  height: 100%;
}
.top-cont {
  height: 44px;
}
.head {
  font-size: 0;
  padding: 13px 0;
  background: #fff;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 12;
  box-sizing: border-box;

  p {
    width: 33.33%;
    display: inline-block;
    text-align: center;

    span {
      font-size: 14px;
      color: #666;
      padding: 11px 0;

      &.active {
        color: #ff98a0;
        border-bottom: 2px solid #ff98a0;
      }
    }
  }
}
.van-tabs {
  /deep/ .van-tabs__wrap {
    position: relative;
    z-index: 100;

    .van-tabs__nav {
      .van-tab {
        &.van-tab--active {
          color: #ff98a0;
        }
      }
    }
  }

  /deep/ .van-tabs__content {
    position: fixed;
    top: 44px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 80;
    overflow-y: auto;
    background-color: #f8f8f8;
  }
}

.voucher-list {
  padding: 15px 15px;

  .list {
    height: 110px;
    margin-top: 10px;
    background: url('http://freesaasofficedata.oss.aliyuncs.com/rolorweb/20230411100307813.png')
      no-repeat;
    background-size: 100% 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .look-source {
      position: absolute;
      left: 2%;
      bottom: 10px;
      font-size: 9px;
      color: #fff;
      background: #8db1c1;
      display: inline-block;
      border-radius: 20px;
      line-height: 12px;
      padding: 2px 10px;
      text-align: center;
    }

    .win-prize {
      width: 27%;
      display: inline-block;
      text-align: center;

      p {
        font-size: 12px;
        color: #333;

        &.pad {
          padding: 12px 0;
        }

        &.print {
          font-size: 9px;
          padding: 8px 10px;
          text-align: center;
          line-height: 13px;
        }
      }

      .prize-name {
        padding: 0 5px;

        p {
          color: #333;
          font-size: 22px;

          &:nth-child(2) {
            margin: 6px 0;
            font-size: 12px;
          }
        }
      }

      .view-delivery {
        color: #333;
        padding-top: 10px;
        display: block;
        position: relative;
        z-index: 10;
      }

      .prize-img {
        width: 35px;
        max-height: 40px;
      }

      .logo-small {
        width: 42px;
        height: 58px;
      }
    }

    .chapter {
      width: 81px;
      height: 61px;
      position: absolute;
      bottom: 0;
      right: 12%;
    }

    &:first-child {
      margin-top: 0;
    }

    &.gray {
      background: url('http://freesaasofficedata.oss.aliyuncs.com/rolorweb/20230411100334246.png')
        no-repeat;
      background-size: 100% 100%;

      .look-source {
        background-color: #aaaaaa;
      }
    }
  }
}
.qr-code {
  height: 100%;
  box-sizing: border-box;
  background: url('http://freesaasofficedata.oss.aliyuncs.com/rolorweb/20230413111622414.png')
    no-repeat #fff;
  background-size: 100% auto;

  .qr-title {
    text-align: center;
    position: relative;

    .theme {
      width: 146px;
    }

    .level-logo {
      position: absolute;
      right: 14%;
      bottom: 10px;
      width: 75px;
    }
  }

  .qr-cont {
    width: 300px;
    height: 330px;
    margin-top: 50%;
    display: inline-block;
    background: #fff;
    border-radius: 8px;
    position: relative;

    .room-num {
      height: 120px;
      text-align: center;
      border-bottom: 1px dashed #e5e5e5;
      position: relative;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      .txt1 {
        font-size: 12px;
        color: #666;
        padding: 10px 0;
      }

      .txt2 {
        font-size: 30px;
        color: #ff98a0;
        padding-top: 12px;
      }

      .txt3 {
        p {
          color: #da0c12;
          font-size: 16px;

          .txt-large {
            font-size: 44px;
            font-weight: bold;
          }

          .txt-black {
            color: #333;
          }

          .performance {
            padding: 0 3px;
            display: inline-block;
            border-radius: 16px;
            background-color: #f6f6f6;
          }
        }
      }

      &:before {
        content: '';
        width: 20px;
        height: 20px;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        left: -10px;
        bottom: -10px;
        background: #fff;
      }

      &:after {
        content: '';
        width: 20px;
        height: 20px;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        right: -10px;
        bottom: -10px;
        background: #fff;
      }
    }

    .qrcode-img {
      padding-top: 20px;
      text-align: center;

      img {
        width: 172px;
        height: 172px;
      }
    }

    &:before {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 10px;
      right: 10px;
      height: 30px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 7px;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: -20px;
      left: 20px;
      right: 20px;
      height: 50px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 7px;
    }
  }

  .md-logo {
    position: absolute;
    left: calc(50% - 31px);
    bottom: 10px;

    img {
      width: 62px;
    }
  }
}
.layer {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 88;

  .source {
    width: 300px;
    height: 130px;
    position: absolute;
    left: calc(50% - 150px);
    top: calc(50% - 65px);
    background: #fff;
    border-radius: 6px;

    .modal-cha {
      width: 24px;
      height: 24px;
      display: inline-block;
      border-radius: 50%;
      background: #f1f1f1;
      position: absolute;
      right: 0;
      top: 0;
      margin: 10px;
      color: #666;
      text-align: center;
      line-height: 24px;
      font-size: 12px;

      &:before {
        content: '\e9c5';
      }
    }

    .so-tit {
      font-size: 16px;
      color: #666666;
      padding: 15px 0;
      text-align: center;
    }

    .so-cont {
      padding: 0 30px;
      line-height: 24px;
      text-align: left;

      p {
        font-size: 12px;
        color: #666;

        span {
          color: #999;
        }
      }
    }
  }

  .stage {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);

    img {
      max-width: 100%;
    }
  }
}

.empty-content {
  padding-top: 20%;

  img {
    width: 50%;
  }

  p {
    color: #999;
    letter-spacing: 2px;
    font-size: 16px;
    padding-top: 10px;
  }
}

.ivv-layer .content .title {
  color: #666;
  font-size: 16px;
  font-weight: bold;
  line-height: 48px;
  letter-spacing: 1px;
}

.ivv-layer .content .line {
  padding-bottom: 5px;
  height: 1px;
  border-top: 1px solid #f1f1f1;
}

.ivv-layer .content .prompt {
  color: #666;
  font-size: 12px;
  letter-spacing: 1px;
}

.ivv-layer .content .count {
  color: #ff98a0;
  padding: 11px 0;
}

.ivv-layer .content .count span {
  color: #ff98a0;
  font-size: 24px;
}

.ivv-layer .content > img {
  width: 310px;
}

.ivv-layer .content .icon-ivv-close {
  color: #666;
  position: absolute;
  top: 15px;
  right: 15px;
}

.ivv-layer .content .icon-ivv-close:before {
  content: '\e9d6';
  font-size: 24px;
}
.ivv-layer .content.years-cont {
  border: 10px solid #fa1313;
}
.ivv-layer .content.years-cont .hint {
  font-size: 10px;
  color: #fa1313;
  padding: 10px 0 10px;
}
.years-cont .y-list {
  text-align: left;
  padding: 0 15px;
}
.years-cont .y-list-margin{
  margin-top: 30px;
}
.years-cont .y-list span {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 4px;
  display: block;
}
.years-cont .y-list span em{
  color: #fa1313;
}
.years-cont .y-list .li {
  margin-bottom: 10px;
}
.years-cont .y-list .li p {
  font-size: 14px;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.years-cont .y-list .li p .van-tag {
  margin-left: 10px;
  font-size: 12px;
  margin-top: 5px;
}
.years-cont .y-list .li p em {
  font-size: 14px;
  // font-weight: bold;
  color: #fa1313;
  font-style: normal;
}
.years-cont .y-list .li p em.rig {
  padding-left: 10px;
}
.slot-record-list{
  > img {
    width: 100%;
  }
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('http://freesaasofficedata.oss.aliyuncs.com/miShop/20250923100438383.jpg');
    background-size: 100% 100%;
  }
  .title {
    position: absolute;
    top: 52px;
    left: 0;
    right: 0;
    z-index: 30;
    text-align: center;
    img {
      width: 290px;
    }
  }
  .record-list {
  position: absolute;
  top: 92px;
  left: 22px;
  right: 22px;
  bottom: 60px;
  padding: 15px;
  overflow-y: auto;
  z-index: 10;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #deed53;
  .record-item {
    display: flex;
    padding: 15px 0;
    align-items: center;
    border-bottom: 1px solid #deed53;
    > img {
      width: 43px;
      height: 43px;
      margin-right: 10px;
    }
    .git-cont {
      width: calc(100% - 123px);
      .name {
        color: #000000;
        margin-bottom: 10px;
      }
      .time {
        color: #999999;
        font-size: 10px;
      }
    }
    .state {
      width: 70px;
      color: #ffb5bb;
      text-align: right;
    }
    &:last-child {
      border-bottom: none;
    }
  }
  /deep/ .van-empty__image {
    padding-top: 10%;
    width: 200px;
    height: auto;
  }
}
}
</style>
